(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Transaction.Capture.NeededDocuments",
                {
                    url: "/Documents",
                    component: "neededDocuments",
                    resolve: {
                        transactionDocuments: ["transactionDocumentApi", "transaction", function (transactionDocumentApi, transaction) {
                            return transactionDocumentApi.getTransactionDocumentsByType(transaction.Id, "CaptureDocument");
                        }],
                        prevStage: ["transaction", "transactionApi", "_", function (transaction, transactionApi, _) {
                            var currIndex = _.findIndex(transaction.CapturePoints,
                                function (capturePoint) {
                                    return capturePoint === "NeededDocuments";
                                });

                            if (currIndex === 0) {
                                return transactionApi.getDisclosures(transaction.Id).then(function(disclosures) {
                                    return disclosures.length === 0 ? null : "Transaction.Disclose";
                                });
                            } else return "Transaction.Capture." + transaction.CapturePoints[currIndex - 1];
                        }],
                        nextStage: ["transaction", "_", function (transaction, _) {
                            var currIndex = _.findIndex(transaction.CapturePoints,
                                function (capturePoint) {
                                    return capturePoint === "NeededDocuments";
                                });

                            return currIndex === transaction.CapturePoints.length - 1
                                ? "Transaction.Determine.ProductChoice"
                                : "Transaction.Capture." + transaction.CapturePoints[currIndex + 1];
                        }]
                    },
                    onEnter: ["transactionApi", "transaction", function (transactionApi, transaction) {
                        transaction.LastTransactionStage = "NeededDocuments";
                        transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                    }]
                });
        }
    ]);
    app.component("neededDocuments",
        {
            templateUrl: "/App/Transaction/Capture/NeededDocuments/template.html",
            controller: neededDocumentsController,
            bindings: {
                transaction: "<",
                transactionDocuments: "<",
                nextStage: "<",
                prevStage: "<",
                transactionGroup: "<"
            }
        });

    neededDocumentsController.$inject = ["$scope", "$state", "_", "transactionDocumentApi"];
    function neededDocumentsController($scope, $state, _, transactionDocumentApi) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    Saving: []
                },
                newTransactionDocuments: [],
                next: next,
                upload: upload
            });

        function next(event) {
            $state.go($ctrl.nextStage, { transactionId: $ctrl.transaction.Id });
        };

        function upload(file, index, requiredDocumentName) {
            if (file !== null) {
                $ctrl.ui.Saving[index] = true;
                var payload = new FormData();

                if ($ctrl.sortedTransactionDocuments[index]) {
                    payload.append("updateTransactionDocument", file, file.name);
                    transactionDocumentApi
                        .updateTransactionDocument($ctrl.transaction.Id,
                        $ctrl.sortedTransactionDocuments[index].Id,
                        payload).then(function (response) {
                            $ctrl.sortedTransactionDocuments[index] = response;
                            $ctrl.ui.Saving[index] = false;
                        });
                } else {
                    payload.append("transactionDocument", file, file.name);
                    transactionDocumentApi.addTransactionDocument($ctrl.transaction.Id, "CaptureDocument", requiredDocumentName, payload)
                        .then(function (response) {
                            $ctrl.sortedTransactionDocuments[index] = response;
                            $ctrl.ui.Saving[index] = false;
                        });
                }
            } else {
                return $ctrl.sortedTransactionDocuments[index];
            }
        };

        this.$onInit = function() {
            $ctrl.sortedTransactionDocuments = [];

            var index = 0;
            ng.forEach($ctrl.transaction.RequiredCaptureDocuments, function (fileName) {
                var doc = _.find($ctrl.transactionDocuments, function (d) {
                    return d.RequiredFileName === fileName;
                });

                if (doc)
                    $ctrl.sortedTransactionDocuments[index] = doc;
                index++;
            });

            $ctrl.newTransactionDocuments = _.clone($ctrl.sortedTransactionDocuments);
        };

    };

})(window.app, window.angular); //jshint ignore:line